import { SET_TERMS_OF_USE_ACCEPTED } from '../actions/paymentForm';

const initialState = {
    termsOfUseAccepted: false,
    showPayPalOverlay: true
};

export default function paymentForm(state = initialState, { type, payload }) {
    switch (type) {
        case SET_TERMS_OF_USE_ACCEPTED:
            return {
                ...state,
                termsOfUseAccepted: payload.termsOfUseAccepted
            };
        default:
            return state;
    }
}
